import { inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../models';

/**
 *
 */
export class AppConfigService {
  private readonly _environmentConfig = inject(APP_CONFIG);
  private _localConfig: AppConfig = { ...this._environmentConfig };

  /**
   * Application Configuration.
   *
   * @returns app configuration
   */
  get config(): AppConfig {
    return this._localConfig;
  }

  /**
   * Patch application configuration.
   * Partially update config with a new value.
   *
   * @param config - partial configuration
   * @returns config - updated config
   */
  patchConfig(config: Partial<AppConfig>): AppConfig {
    this._localConfig = { ...this._localConfig, ...config };
    return this._localConfig;
  }
}
